import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'anyMatch' })
export class AnyMatchPipe implements PipeTransform {
  transform(entries: any[] = [], predicate: (any) => boolean = () => true): any {
    return entries.some(predicate);
  }
}
